const hogesEventTypes = require('./hoges');

/**
 * HE-LEARNING CUSTOM EVENT NAMING CONVENTION
 * E-{Abbreviature of the app}-{Abbreviature of event description}
 * Example: EV-HST-XXX
 */
module.exports = {
  ...hogesEventTypes,
};
